export const environment = {
  production: 'false',
  adfsAuthority: 'https://auth.alliedpilots.org/adfs/',
  apiUrl: 'https://mytripservice.alliedpilots.org/',
  flightDataServiceUrl: 'https://apagateway.alliedpilots.org/pilotflightdataservice/search',
  crewBasicUrl:
    'https://apagateway.alliedpilots.org/userprofileservice/UserService/GetUsersBasicInfo',
  crewDetailUrl:
    'https://apagateway.alliedpilots.org/memberinfoservice/api/Membership/LookupDetails',
  clientId: 'https://mytrip.alliedpilots.org',
  customAuthRequestResource: 'https://mvcapi.alliedpilots.org',
  apimSubscriptionKey: '54c168e7b1684078baf2d534a63e9e0d',
  prefix: '.',
};
